import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import errorIcon from "../../../assets/icons/errorIcon.svg"
import { Container, FormWrapper, InputWrapper, Tooltip } from "./CreatePublishersStyles";

import { createPublisher } from "../../../redux/slices/publisherSlice";

import BackButton from "../../../components/common/BackButton";
import PostbackFields, { parsePostbackBody } from "../../../components/common/PostbackFields";
const CreatePublishers = ({ loading }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleFocus = () => setShowTooltip(true);
  const handleBlur = () => {
    setShowTooltip(false);
    if (!formData.publisherUrl.startsWith("http://") && !formData.publisherUrl.startsWith("https://")) {
      Swal.fire({
        title: "Invalid URL",
        html: "The URL must start with <strong>'http://'</strong> or <strong>'https://'</strong>. Please correct it.",
        icon: null, 
      iconHtml:
          `<img src=${errorIcon} alt="error" style="width:50px;">`,
        confirmButtonText: "Okay",
      });
    }
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    publisherUrl: "",
    //publisherCPA: "",
    identifier: "",
    clickIdParameter: "",
    sourceIdParameter: "",
    postbackMethod: "GET",
    postbackBody: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,

    });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    if (!formData.publisherUrl.startsWith("http://") && !formData.publisherUrl.startsWith("https://")) {
      Swal.fire({
        title: "Invalid URL",
        html: "The URL must start with <strong>'http://'</strong> or <strong>'https://'</strong>. Please correct it.",
        icon: null, 
      iconHtml:
          `<img src=${errorIcon} alt="error" style="width:50px;">`,
        confirmButtonText: "Okay",
      });
      return
    }
    //dispatch(createPublisher(formData));

    const { postbackBody, ...rest } = formData;
    const payload = { ...rest };
    if (formData.postbackMethod === "POST") {
      const { body, error } = parsePostbackBody(postbackBody);
      if (error) {
        Swal.fire({
          title: "Invalid postback body",
          text: error,
          icon: null,
          iconHtml: `<img src=${errorIcon} alt="error" style="width:50px;">`,
          confirmButtonText: "Okay",
        });
        return;
      }
      payload.postbackBody = body;
    }

    try {
      // const updatedFormData = {
      //   ...formData,
      //   publisherCPA: parseFloat(formData.publisherCPA), // Ensure it's a float
      // };
      const result = await dispatch(createPublisher(payload)).unwrap();
      if (result.statusCode === 201) {
        navigate("/publishers");
      } else {
        // Handle API errors if needed
        console.error("Failed to create publisher:", result.message);
      }
    } catch (error) {
      console.error("Error creating publisher:", error);
    }
  };

  return (
    <>
    <BackButton></BackButton>
    <Container>
      <div className="header">
        <div className="texts">
          <h3>Create Publishers</h3>
          <p>Register a new publisher.</p>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <FormWrapper>
          <label htmlFor="name">Publisher name</label>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Publisher name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        <FormWrapper>
          <label htmlFor="publisherUrl">Postback url</label>
          <InputWrapper>
          <input
            type="text"
            id="publisherUrl"
            name="publisherUrl"
            placeholder="Url"
            value={formData.publisherUrl}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            required
          />
          {showTooltip && (
          <Tooltip>
            <strong>Tracking Parameters</strong>
            <p>use {'{clickID}'} to track click id, and {'{sourceID}'} to track<br/> 
              sub source eg:  {'https://google.com?clickId={clickID}&sourceId={sourceID}'}</p>
          </Tooltip>
        )}
        </InputWrapper>
        </FormWrapper>

        <FormWrapper>
          <label htmlFor="identifier">Identifier</label>
          <input
            type="text"
            id="identifier"
            name="identifier"
            placeholder="identifier"
            value={formData.identifier}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        <FormWrapper>
          <label htmlFor="clickIdParameter">Click ID macro</label>
          <input
            type="text"
            id="clickIdParameter"
            name="clickIdParameter"
            placeholder="Click Id"
            value={formData.clickIdParameter}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        <FormWrapper>
          <label htmlFor="sourceIdParameter">Source ID macro</label>
          <input
            type="text"
            id="sourceIdParameter"
            name="sourceIdParameter"
            placeholder="Source Id"
            value={formData.sourceIdParameter}
            onChange={handleChange}
            required
          />
        </FormWrapper>

        <PostbackFields
          method={formData.postbackMethod}
          body={formData.postbackBody}
          onChange={handleChange}
          Wrapper={FormWrapper}
        />

        {/* <FormWrapper>
          <label htmlFor="publisherCPA">Publisher CPA</label>
          <input
            type="text"
            id="publisherCPA"
            name="publisherCPA"
            placeholder="Publisher CPA"
            value={formData.publisherCPA}
            onChange={handleChange}
            required
          />
        </FormWrapper> */}

        <div className="submit">
          <div></div>
          <div className="submit-buttons">
            <button className="add-campaign" type="submit" disabled={loading}>
              {loading ? "Creating..." : "Create"}
            </button>
          </div>
        </div>
      </form>
    </Container>
    </>
  );
};

export default CreatePublishers;
